function TrendingMagnetCardSkeleton() {
  return (
    <div className="magnet-price-card-background flex w-72 animate-pulse snap-mandatory snap-start flex-col rounded-2xl border border-white p-2 2xl:w-80 2xl:p-3 4xl:w-96">
      <div className="aspect-h-1 aspect-w-1 w-96 max-w-full grow cursor-pointer rounded-2xl border-2 border-white border-opacity-60 bg-gray-400" />
      <div className="flex h-32 flex-col justify-between 2xl:h-40">
        <div
          className="mt-2 line-clamp-2 h-7 w-[70%] rounded-full
          bg-gray-500 text-left font-satoshi text-2xl font-bold leading-tight text-primary first-letter:uppercase 2xl:text-3xl"
        />
        <div className="flex flex-col space-y-1 text-start">
          <div className="h-5 w-[50%] rounded-full bg-gray-500 font-satoshi text-lg font-bold text-primary opacity-90 2xl:text-xl" />
          <div className="h-5 w-[60%] rounded-full bg-gray-500 font-satoshi text-lg font-bold text-primary opacity-80 2xl:text-xl" />
        </div>
      </div>
    </div>
  );
}

export default TrendingMagnetCardSkeleton;
